/**
 * Legacy branding-key redirects for rebranded hotels.
 *
 * The console routes by brandingKey (/:brandingKey/...). When a hotel is
 * rebranded its brandingKey changes, so bookmarked /old-key/... URLs stop
 * resolving. This maps an old key to its new one so those links forward to
 * /new-key/... instead of 404ing.
 *
 * Mirror of the public-interface redirect
 * (public-interface/src/utils/redirects.ts) — keep the two in sync.
 */
export const LEGACY_REDIRECTS = {
  'novotel-brighton': 'the-brighton',
  'hotel-x': 'the-alva',
  hiexqueenstown: 'voco-queenstown',
  'manly-pacific-sydney': 'elysium-manly',
  'rydges-camperdown': 'landmark-camperdown',
};

/** Returns the new branding key for a legacy key, or null if not a legacy key. */
export const getNewBrandingKey = (key) =>
  Object.prototype.hasOwnProperty.call(LEGACY_REDIRECTS, key)
    ? LEGACY_REDIRECTS[key]
    : null;
